module.exports = __webpack_public_path__ + "img/IFC.46ce8ac1.svg";